import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { TranslateModule, TranslatePipe } from "@ngx-translate/core";
import { NgSelectModule } from '@ng-select/ng-select';
import { isNullOrZero } from "../common/utils";
import { CustomAlertService } from "../common/service/custom-alert.service";
import { PreferenciasUsuarioService } from "../common/service/preferencias-usuario.service";
import { PreferenciasUsuario } from "../common/model/preferencias-usuario";
import { Carteira } from "../common/model/carteira";
import { CarteiraService } from "../common/service/carteira.service";
import { Lista } from "../common/model/lista";
import { ListaService } from "../common/service/lista.service";
import { Credential } from "../../modules/autenticacao/model/credential";
import { ContaService } from "../common/service/conta.service";
import { LayoutEventsService } from "../common/service/layout-events.service";
import { StorageProxy } from "../common/service/storage-proxy.service";
import { LookupData } from "../common/model/lookup";
import { Router } from "@angular/router";

@Component({
    selector: "app-preferencias-usuario-modal",
    templateUrl: "./preferencias-usuario-modal.component.html",
    styleUrls: ["./preferencias-usuario-modal.component.scss"],
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        MatButtonModule,
        MatIconModule,
        TranslatePipe,
        NgSelectModule
    ],
    providers: [
        { useClass: PreferenciasUsuarioService, provide: PreferenciasUsuarioService },
        { useClass: ContaService, provide: ContaService },
        { useClass: CarteiraService, provide: CarteiraService },
        { useClass: ListaService, provide: ListaService },
        { useClass: CustomAlertService, provide: CustomAlertService }
    ]
})
export class PreferenciasUsuarioModalComponent {
    preferencias: PreferenciasUsuario;
    hashConta: string | null;
    contas: Array<any> = [];
    carteiras: Array<Carteira> = [];
    listas: Array<Lista>;

    public get existePreferenciaCarteira(): boolean {
        return this.preferencias.existePreferenciaCarteira;
    }

    constructor(
        private preferenciasService: PreferenciasUsuarioService,
        private contaService: ContaService,
        private layoutEventsService: LayoutEventsService,
        private carteiraService: CarteiraService,
        private listaService: ListaService,
        private router: Router,
        public dialogRef: MatDialogRef<PreferenciasUsuarioModalComponent>,
        private customAlertService: CustomAlertService,
        @Inject(MAT_DIALOG_DATA)
        public data: {}
    ) {
        this.preferencias = new PreferenciasUsuario();
        this.obterClientes();
        this.obterPreferencias();
        this.obterCarteiras();
    }

    obterClientes() {
        this.contaService.obterLookup().subscribe((contas: LookupData) => {
            this.contas = this.ordenarPorLabel(contas.data ?? []);
            this.hashConta = StorageProxy.get<Credential>('userData').user.properties.hashConta;
        });
    }

    clienteChange() {
        this.contaService.alterarContaLoginUsuario(this.hashConta).subscribe((result: any) => {
            this.layoutEventsService.onLoginChange.emit();
            this.router.navigate(["/app/home"]);
            this.dialogRef.close();
        });
    }

    obterPreferencias() {
        this.preferenciasService.obterPorUsuario().subscribe((preferencias: PreferenciasUsuario) => this.preferencias = preferencias);
    }

    obterCarteiras() {
        this.carteiraService.obterCarteiras().subscribe((carteiras: Array<Carteira>) => {
            this.carteiras = this.ordenarPorNome(carteiras);
            this.obterListas();
        });
    }

    obterListas() {
        this.listaService.obterListaSemQuantidade({ "carteiraId": this.preferencias.carteiraId }).subscribe((listas: Array<Lista>) => {
            this.listas = this.ordenarPorNome(listas ?? []);
        });
    }

    /** Ordenação alfabética por nome (A–Z), locale pt-BR. */
    private ordenarPorNome<T extends { nome?: string }>(itens: T[]): T[] {
        return [...itens].sort((a, b) =>
            (a.nome ?? "").localeCompare(b.nome ?? "", "pt-BR", { sensitivity: "base" })
        );
    }

    /** Ordenação alfabética por label (lookup), locale pt-BR. */
    private ordenarPorLabel<T extends { label?: string }>(itens: T[]): T[] {
        return [...itens].sort((a, b) =>
            (a.label ?? "").localeCompare(b.label ?? "", "pt-BR", { sensitivity: "base" })
        );
    }

    carteiraChange(event: any) {
        this.preferencias.listaId = null;
        this.obterListas();
    }

    gravar() {
        const requisicao = (isNullOrZero(this.preferencias.preferenciaUsuarioId))
            ? this.preferenciasService.criar(this.preferencias)
            : this.preferenciasService.atualizar(this.preferencias);

        requisicao.subscribe(
            (result: PreferenciasUsuario) => {
                this.customAlertService.show("telaPreferenciasUsuario.preferenciasUsuario", "telaPreferenciasUsuario.salvarPreferencias", "success");
                this.preferenciasService.localStorageGravarPreferenciasUsuario(result);
                this.dialogRef.close();
            },
            (error: any) => {
                this.customAlertService.show("telaPreferenciasUsuario.preferenciasUsuario", error.error[0], "error");
            });
    }

    fechar() {
        this.dialogRef.close();
    }
}
